/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/jsx-key */
import * as React from 'react';
import { css } from 'styled-components';
import { checkValue } from 'src/components/common/helper';

// Module Context
//import { useComponentContext } from 'src/components/common/modules/component-layout/component-context';

// Components
import Layout from 'src/components/common/theme/Layout';
import { ModuleProps } from 'src/components/common/module-util';
//import { FigureComponent, Typo } from 'src/components/common/ui';
//import { getDeviceImage } from 'src/components/common/theme/component';
import { useWindowDimensions } from 'src/components/common/useWindowDimentions';
//import { UitkFigureAspectRatioType } from 'uitk-react-images';
import ImageCard from './image-card';
import { Typo } from 'src/components/common/ui';

// Css Style Import
import(/* webpackChunkName: "v1-three-card-image-styles" */ 'src/components/common/modules/v1/three-card-image/styles/three-card-image.css');

const ThreeCardImage = (props: ModuleProps) => {
  const {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    data: { bannerText, bannerImageItems, bannerTextColor, uniquekey },
    id,
  } = props;
  const { width: windowWidth } = useWindowDimensions();

  let windowSize = '';
  if (windowWidth > 920) windowSize = 'desktop';
  else if (windowWidth > 575) windowSize = 'tablet';
  else windowSize = 'mobile';

  // Dynamic style overrides
  const moduleCss = () => {
    return `
    ${
      checkValue(bannerTextColor)
        ? `h2.cms-typo{
          color: ${bannerTextColor} !important;
        }`
        : ''
    } 
    `;
  };

  return (
    <>
      <Layout
        HtmlTag="section"
        className="three-card-image"
        css={css`
            ${moduleCss()}
          `}
        id={id}
      >
        <div className={`three-card-image-item`}>
          {bannerImageItems.map((bannerItem) => (<ImageCard {...bannerItem}/>))}
          <div className="image-card-info">
            <div className={`image-card-info-upper`}>
              <Typo.HTMLText tag="h2" exClass="title override-heading-font-family">
                {bannerText}
              </Typo.HTMLText>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default ThreeCardImage;
